module.exports = __webpack_public_path__ + "img/glnpay.a36b79f1.png";